import React from "react";
import { parseWalkInMobile } from "../../../helpers/walkInValidation";

export const CONFIRM_TITLE = "Please double-check your details";
export const CONFIRM_NOTICE =
  "The host will use these to call you. If your number or email is wrong, we may not be able to reach you when your table is ready.";

const rowStyle = {
  display: "flex",
  justifyContent: "space-between",
  gap: "1rem",
  padding: "0.4rem 0",
  borderBottom: "1px solid #f0f0f0",
};
const labelStyle = { color: "#6c757d", margin: 0 };
const valueStyle = {
  margin: 0,
  fontWeight: 600,
  textAlign: "right",
  wordBreak: "break-word",
};

/**
 * Read-back of what the guest typed, shown before they join the queue.
 * Guest input is rendered as React text children, never as HTML.
 */
export const WalkInDetailsSummary = ({
  firstName,
  lastName,
  email,
  mobileNumber,
  partySize,
}) => {
  const mobile = parseWalkInMobile(mobileNumber);
  const rows = [
    ["Name", `${firstName || ""} ${lastName || ""}`.trim()],
    ["Mobile", mobile.valid ? mobile.display : mobileNumber],
    ["Email", (email || "").trim()],
    ["Party size", String(partySize)],
  ];

  return (
    <div style={{ textAlign: "left" }}>
      <dl style={{ marginBottom: "1rem" }}>
        {rows.map(([label, value]) => (
          <div key={label} style={rowStyle}>
            <dt style={labelStyle}>{label}</dt>
            <dd style={valueStyle}>{value}</dd>
          </div>
        ))}
      </dl>
      <p className="text-muted mb-0" style={{ fontSize: "0.9rem" }}>
        {CONFIRM_NOTICE}
      </p>
    </div>
  );
};

/**
 * @param {object} values the join form's values
 * @param {{fire: Function}} MySwal a withReactContent-wrapped SweetAlert
 * @returns {Promise<boolean>} true only when the guest confirms
 */
export const confirmWalkInDetails = async (values, MySwal) => {
  const result = await MySwal.fire({
    title: CONFIRM_TITLE,
    html: (
      <WalkInDetailsSummary
        firstName={values.firstName}
        lastName={values.lastName}
        email={values.email}
        mobileNumber={values.mobileNumber}
        partySize={values.partySize}
      />
    ),
    showCancelButton: true,
    confirmButtonText: "Yes, join the queue",
    cancelButtonText: "Edit details",
    reverseButtons: true,
    confirmButtonColor: "#8950fc",
  });

  return Boolean(result && result.isConfirmed);
};
